import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import About from './components/About';
import Education from './components/Education';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import headerBackground from './images/header-background.png';
import profileImage from './images/header-image.png';

function App() {
  const headerStyle = {
    backgroundImage: `url(${headerBackground})`,
  };

  const [educationInView, setEducationInView] = useState(false);
  const [projectsInView, setProjectsInView] = useState(false);
  const [contactInView, setContactInView] = useState(false);

  const educationRef = useRef(null);
  const projectsRef = useRef(null);
  const contactRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.3, // Trigger when 30% of the item is visible
    };

    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.target === educationRef.current) {
          setEducationInView(entry.isIntersecting);
        } else if (entry.target === projectsRef.current) {
          setProjectsInView(entry.isIntersecting);
        } else if (entry.target === contactRef.current) {
          setContactInView(entry.isIntersecting);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    if (educationRef.current) observer.observe(educationRef.current);
    if (projectsRef.current) observer.observe(projectsRef.current);
    if (contactRef.current) observer.observe(contactRef.current);

    return () => {
      if (educationRef.current) observer.unobserve(educationRef.current);
      if (projectsRef.current) observer.unobserve(projectsRef.current);
      if (contactRef.current) observer.unobserve(contactRef.current);
    };
  }, []);

  return (
    <div className="App">
      <Navbar />
      <header id="home" className="App-header" style={headerStyle}>
        <div className="header-image-container">
          <img src={profileImage} alt="Samitha Michael" />
        </div>
        <div className="header-text-container">
          <h1>SAMITHA MICHAEL</h1>
          <h2>QUALITY ASSURANCE ENGINEER</h2>
        </div>
      </header>
      <About />
      <Education ref={educationRef} isInView={educationInView} />
      <Projects ref={projectsRef} isInView={projectsInView} />
      <Contact ref={contactRef} isInView={contactInView} />
      <Footer />
    </div>
  );
}

export default App;